import { render, staticRenderFns } from "./CarForm.vue?vue&type=template&id=5d2c5399"
import script from "./CarForm.vue?vue&type=script&lang=js"
export * from "./CarForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports